import { useMsalAccessToken } from './useMsalAccessToken';

export const hasRole = (requiredRoles: string[], userRoles: string[]) => {
  return requiredRoles.some((role) => userRoles.includes(role));
};

export interface FeatureGuardProps {
  requiredRoles: string[];
  children: React.ReactNode;
}

export const FeatureGuard: React.FC<FeatureGuardProps> = ({ requiredRoles, children }) => {
  const { account } = useMsalAccessToken();
  const userRoles = account?.idTokenClaims?.roles || [];
  if (!hasRole(requiredRoles, userRoles)) {
    return null;
  }
  return <>{children}</>;
};
